module.exports = __webpack_public_path__ + "img/54_9.eb9f1c8e.png";